import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./static/styles/common.scss";
import "./static/styles/modal-base.scss";
import "rc-slider/assets/index.css";
import App from "./App";
// import * as serviceWorker from './serviceWorker';

import "./i18n";

if (!process.env.REACT_APP_ENABLE_CONSOLE_LOGS) {
  console.log = () => {};
  console.warn = () => {};
  console.clear();
  console.info = () => {};
  console.timeLog = () => {};
}
const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
